import { httpRequest } from "../../../utils/HttpRequest";
import { ISalesList, ISalesSearch } from "./salesTypes"
class Salesservice {
    async saleAmount(params: ISalesSearch) {
        const apiUrl = `/vrm-sa/statistics/saleAmount`;
        return await httpRequest.post<ISalesList>(apiUrl, params);
    }
    async export(params: ISalesSearch) {
        const apiUrl = "/vrm-sa/sale/export";
        return await httpRequest.postFile(apiUrl, params);
    }
}
export const salesService = new Salesservice();
